export const INDENT_IN_PARAGRAPH = 'indent_in_paragraph';
